import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { collection, query, getDocs, where } from 'firebase/firestore';
import { db } from '../../firebase';

function Featured() {
  const [amount, setAmount] = useState(null);
  const [lweek, setLWeek] = useState(null);
  const [lmonth, setLMonth] = useState(null);
  const [diff, setDiff] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const today = new Date();
      const lastDay = new Date(new Date().setHours(today.getHours() - 24));
      const lastWeek = new Date(new Date().setDate(today.getDay() - 6));
      const lastMonth = new Date(new Date().setMonth(today.getMonth() - 1));
      const twoMonth = new Date(new Date().setMonth(today.getMonth() - 2));

      const lastDayQuery = query(
        collection(db, 'users'),
        where('timeStamp', '<=', today),
        where('timeStamp', '>', lastDay)
      );

      const twoMonthQuery = query(
        collection(db, 'users'),
        where('timeStamp', '<=', lastMonth),
        where('timeStamp', '>', twoMonth)
      );

      const lastWeekQuery = query(
        collection(db, 'users'),
        where('timeStamp', '<=', today),
        where('timeStamp', '>', lastWeek)
      );

      const lastMonthQuery = query(
        collection(db, 'users'),
        where('timeStamp', '<=', today),
        where('timeStamp', '>', lastMonth)
      );

      const lastMonthData = await getDocs(lastMonthQuery);
      const twoMonthData = await getDocs(twoMonthQuery);
      const lastWeekData = await getDocs(lastWeekQuery);
      const lastDayData = await getDocs(lastDayQuery);

      setLMonth(lastMonthData.docs.length);
      setLWeek(lastWeekData.docs.length);
      setAmount(lastDayData.docs.length);

      setDiff((((lastMonthData.docs.length - twoMonthData.docs.length) / twoMonthData.docs.length) * 100).toFixed(0));
    };
    fetchData();
  }, []);

  return (
    <FeaturedStyled>
      <div className="top">
        <h1 className="title">Registered today</h1>
      </div>
      <div className="bottom">
        <div className="featured-chart">
          <CircularProgressbar value={diff} text={`${diff}%`} strokeWidth={5} />
        </div>
        <p className="title">Total persons registered today</p>
        <p className="amount">{amount}</p>
        <p className="desc">See how much space you still have in your environment</p>
        <div className="summary">
          <div className="item">
            <div className="item-title">Target</div>
            <div className="item-result">
              <div className="result-amount">21</div>
            </div>
          </div>
          <div className="item">
            <div className="item-title">Last Week</div>
            <div className="item-result ">
              <div className="result-amount">{lweek}</div>
            </div>
          </div>
          <div className="item">
            <div className="item-title">This Month</div>
            <div className="item-result">
              <div className="result-amount">{lmonth}</div>
            </div>
          </div>
        </div>
      </div>
    </FeaturedStyled>
  );
}

const FeaturedStyled = styled.div`
  flex: 2;
  -webkit-box-shadow: 2px 4px 10px 1px rgba(0, 0, 0, 0.4);
  box-shadow: 2px 4px 10px 1px rgba(201, 201, 201, 0.4);
  padding: 10px;

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--accent-blue);

    .title {
      font-size: 16px;
      font-weight: 500;
    }
  }
  .bottom {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;

    .featured-chart {
      width: 220px;
      height: 220px;

      .CircularProgressbar-path {
        stroke: var(--accent-blue);
      }
    }

    .title {
      font-weight: 500;
      color: gray;
    }
    .amount {
      font-size: 30px;
    }
    .desc {
      font-weight: 300;
      font-size: 12px;
      color: gray;
      text-align: center;
    }
    .summary {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .item {
        text-align: center;

        .item-title {
          font-size: 14px;
          color: var(--accent-blue);
        }

        .item-result {
          margin: 10px;
          font-size: 14px;
          text-align: center;
          align-items: center;
          display: block;
          color: gray;
        }
      }
    }
  }
`;

export default Featured;
